import { InjectionToken, WritableSignal } from '@angular/core';

/**
 * O card que hospeda menus do rail (o card-base). Cada `raRailMenu` aberto dentro dele
 * soma um: o rail fica visível e o card sobe acima das barras fixas enquanto durar, sem cada
 * card específico precisar ligar o `popoverOpen` na mão.
 */
export interface RailMenuHost {
    railMenusOpen: WritableSignal<number>;
    /**
     * O painel de formato da mídia (à direita) está com este card. Só deixa o rail à vista:
     * não sobe o card nem esconde o rail dos vizinhos, como um menu aberto faz.
     */
    lookPanelOpen: WritableSignal<boolean>;
}

export const RAIL_MENU_HOST = new InjectionToken<RailMenuHost>('RAIL_MENU_HOST');
